/*
 * SPDX-FileCopyrightText: 2026 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
    AuthService,
    GlobalMessageService,
    GlobalMessageType,
    WindowRef,
} from '@spartacus/core';
import { take } from 'rxjs';
import { LoginFormComponentService } from '@spartacus/user/account/components';
import { MyAccountService } from '../../services/feature/MyAccount/my-account.service';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class KBLoginFormComponentService extends LoginFormComponentService {
    platformId = inject(PLATFORM_ID);
    constructor(
        protected override auth: AuthService,
        protected override globalMessage: GlobalMessageService,
        protected override winRef: WindowRef,
        private myaccountService: MyAccountService
    ) {
        super(auth, globalMessage, winRef);
    }

    override handleCustomLoginError(): void {
        if (isPlatformBrowser(this.platformId)) {
            const userId = sessionStorage.getItem('loginUserId');

            if (userId) {
                this.myaccountService
                    .checkifAccountDisabled(userId).pipe(take(1))
                    .subscribe((res: any) => {
                        const search = window.location.search;
                        if (search.includes('error=')) {
                            if (res.message === 'common.b2b_login_disabled') {
                                this.globalMessage.add({ key: res.message }, GlobalMessageType.MSG_TYPE_ERROR);
                                return; // stop OOTB execution
                            }
                            else {
                                super.handleCustomLoginError();
                            }
                        }
                    });
            }
        }
    }
}
